<template>
  <div class="">
    <div class="plan-form-wrapper">
      <div>
        <div class="bsc-features">Basic information</div>
        <div class="row">
          <div class="col-6">
            <v-text-field
              v-model="name"
              outline
              label="Plan name"
              :error-messages="planNameError"
            ></v-text-field>
          </div>
          <div class="col-6">
            <v-text-field
              v-model="price"
              outline
              label="Price"
              mask="#######"
              append-icon="mdi-currency-bdt"
              :error-messages="planPriceError"
            ></v-text-field>
          </div>
          <div class="col-6">
            <v-text-field
              outline
              v-model="duration_in_days"
              label="Duration (in days)"
              mask="####"
              :error-messages="planDurationError"
            ></v-text-field>
          </div>
          <div class="col-6">
            <v-select
              outline
              v-model="plan_type"
              :items="plan_types"
              label="Plan Type"
              item-value="value"
              item-text="name"
              :error-messages="planTypeError"
            ></v-select>
          </div>
        </div>
        <div class="row features" style="position: relative">
          <div class="mid-ttl">Features</div>
          <v-icon
            @click="addFeature"
            size="20"
            class="icon-class-view"
            style="position: absolute; top: 0.7rem; right: 1.4rem"
            >mdi-plus-box</v-icon
          >
        </div>
        <div :key="index" v-for="(feature, index) in newFeatures">
          <div class="row">
            <div class="col-4">
              <div class="row">
                <div class="col-1 no-padding">
                  <div
                    style="color: #ffffff; background-color: var(--button-color-unfocus); margin-top: 15px;"
                  >
                    {{ index + 1 }}
                  </div>
                </div>
                <div class="col-11 no-padding">
                  <v-select
                    label="Feature"
                    v-model="feature.key"
                    outline
                    :items="keys"
                    item-value="key"
                    item-text="value"
                    @change="checkIfAlreadySelected($event, index)"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="col-4">
              <v-select
                label="Comparator"
                v-model="feature.op"
                outline
                :items="operators"
                item-value="value"
                item-text="name"
              ></v-select>
            </div>
            <div class="col-3">
              <v-text-field
                v-model="feature.value"
                outline
                label="Value"
                mask="#######"
                :error-messages="planFeatureError"
              ></v-text-field>
            </div>
            <div v-if="index > 0" class="col-1 no-padding">
              <div @click="removeFeature(index)" class="remove">Remove</div>
            </div>
          </div>
        </div>
        <div class="btm-ttl">
          <div v-if="newPlan" style="float: left">
            <button
              @click="updatePlan(2)"
              style="margin-left: 1rem"
              class="btn btn-next-new"
            >
              Publish
            </button>
          </div>
          <button @click="cancelAdding" class="btn btn-cancel">Cancel</button>
          <button
            v-if="newPlan"
            @click="updatePlan(1)"
            style="margin-left: 1rem"
            class="btn btn-save-new"
          >
            Save
          </button>
          <button
            v-else
            @click="updatePlan"
            style="margin-left: 1rem"
            class="btn btn-save-new"
          >
            Save
          </button>
        </div>
        <div v-if="warningMessage" class="hint-msg">
          {{ warningMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { IsEmptyObject } from "../../../globalFunctions";
export default {
  name: "add-plan-form",
  validations: {
    name: {
      required
    },
    duration_in_days: {
      required
    },
    price: {
      required
    },
    plan_type: {
      required
    },
    newFeatures: {
      required,
      minLength: minLength(1),
      $each: {
        value: {
          required
        },
        key: {
          required
        },
        op: {
          required
        }
      }
    }
  },
  props: {
    plan: Object,
    features: Array,
    newPlan: Boolean
  },
  data: function() {
    return {
      plan_id: null,
      plan_status: null,
      name: null,
      duration_in_days: null,
      plan_type: null,
      price: null,
      no_job: null,
      no_search_cv: null,
      newFeatures: [],
      keys: [],
      operators: [
        {
          value: "<=",
          name: "Less or Equal"
        },
        {
          value: ">=",
          name: "Greater or Equal"
        }
      ],
      warningMessage: null,
      plan_types: [
        {
          name: "System",
          value: 1
        },
        {
          name: "Custom",
          value: 2
        },
        {
          name: "Free",
          value: 3
        }
      ],
      timeout: null
    };
  },
  methods: {
    cancelAdding() {
      const self = this;
      self.$emit("cancel");
    },
    addFeature() {
      const self = this;
      if (self.newFeatures.length >= self.features.length) {
        self.warningMessage =
          "You have already chosen field for maximum number of available features";
        self.timeout = setTimeout(function() {
          self.warningMessage = null;
        }, 1000);
        return;
      }
      self.newFeatures.push({
        key: "",
        op: "",
        value: ""
      });
    },
    removeFeature(index) {
      this.newFeatures.splice(index, 1);
    },
    checkIfAlreadySelected(ev, index) {
      const self = this;
      let i;
      for (i = 0; i < self.newFeatures.length; i++) {
        if (i !== index && self.newFeatures[i].key === ev) {
          self.newFeatures.splice(index, 1);
          break;
        }
      }
    },
    updatePlan(status) {
      const self = this;
      self.$v.$touch();
      if (!self.$v.$anyError) {
        let plan = {
          plan_name: self.name,
          duration_in_days: parseInt(self.duration_in_days),
          price: parseInt(self.price)
        };
        let i;
        for (i = 0; i < self.newFeatures.length; i++) {
          let val = parseInt(self.newFeatures.value);
          delete self.newFeatures.value;
          self.newFeatures.value = val;
        }
        plan.attributes = {
          conditions: self.newFeatures
        };
        if (self.plan_id) {
          plan.plan_id = self.plan_id;
          plan.plan_status = self.plan_status;
        }
        if (self.newPlan) {
          plan.plan_status = status;
        }
        self.$emit("update-plan", plan);
      }
    }
  },
  computed: {
    planNameError() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    planPriceError() {
      const errors = [];
      if (!this.$v.price.$dirty) return errors;
      !this.$v.price.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    planDurationError() {
      const errors = [];
      if (!this.$v.duration_in_days.$dirty) return errors;
      !this.$v.duration_in_days.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    },
    planFeatureError() {
      const errors = [];
      if (!this.$v.newFeatures.$dirty) return errors;
      this.$v.newFeatures.$anyError && errors.push("All fields are required");
      return errors;
    },
    planTypeError() {
      const errors = [];
      if (!this.$v.plan_type.$dirty) return errors;
      !this.$v.plan_type.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      return errors;
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted() {
    const self = this;
    self.keys = self.features;
    if (!IsEmptyObject(self.plan)) {
      self.plan_id = self.plan.plan_id || null;
      self.plan_status = self.plan.plan_status || null;
      self.name = self.plan.plan_name || null;
      self.plan_type = self.plan.plan_type || null;
      self.duration_in_days = self.plan.duration_in_days || null;
      self.price = self.plan.price || null;
      let i;
      for (i = 0; i < self.plan.features.length; i++) {
        let key = self.plan.features[i].key;
        self.newFeatures.push({
          key: parseInt(key),
          op: self.plan.features[i].op,
          value: self.plan.features[i].value
        });
      }
    } else {
      if (self.keys.length > 0) {
        self.newFeatures.push({
          key: self.keys[0].key,
          op: self.operators[0].value,
          value: ""
        });
      }
    }
  }
};
</script>

<style scoped>
.plan-form-wrapper {
  background-color: #ffffff;
  min-height: 10rem;
  max-width: 100rem;
}
.bsc-features {
  font-size: 2rem;
  text-align: left;
  padding: 1rem 1.7rem;
  font-weight: bold;
  background-color: #edf1fd;
  margin-bottom: 2rem !important;
  color: #5578eb;
}
.features {
  background-color: #edf1fd;
  margin-bottom: 2rem !important;
  color: #5578eb;
}
.mid-ttl {
  font-size: 2rem;
  padding: 1rem 1.7rem;
  font-weight: bold;
  text-align: left;
}
.btm-ttl {
  text-align: right;
  padding: 3rem 1.7rem;
}
.remove {
  color: var(--button-delete-color);
  margin-top: 1.8rem;
  margin-right: 0.5rem;
  border-radius: 0.2rem;
  padding: 1px;
  cursor: pointer;
}
.hint-msg {
  font-size: 1.6rem;
  text-align: center;
  padding: 1rem 1.7rem;
  background-color: var(--button-warning-unfocus);
  margin-bottom: 2rem !important;
}
.v-input {
  text-align: right !important;
}
</style>
